module.exports = __webpack_public_path__ + "img/dsci0043.5d1e3dae.jpg";